"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22859],{

/***/ 825078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ RatingFilled; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RatingFilled = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.1958 18.4749C12.0707 18.4217 11.9293 18.4217 11.8042 18.4749L6.58683 20.6947C6.23942 20.8425 5.8598 20.5667 5.89302 20.1906L6.39193 14.5426C6.40389 14.4072 6.36021 14.2728 6.27095 14.1703L2.5475 9.89418C2.29956 9.60945 2.44457 9.16318 2.81251 9.07856L8.33827 7.80772C8.47074 7.77725 8.58509 7.69417 8.655 7.5776L11.5712 2.715C11.7654 2.39121 12.2346 2.39121 12.4288 2.715L15.345 7.5776C15.4149 7.69417 15.5293 7.77725 15.6617 7.80772L21.1875 9.07856C21.5554 9.16318 21.7004 9.60945 21.4525 9.89419L17.729 14.1703C17.6398 14.2728 17.5961 14.4072 17.6081 14.5426L18.107 20.1906C18.1402 20.5667 17.7606 20.8425 17.4132 20.6947L12.1958 18.4749Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 883578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ CountdownTime; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(621655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(649771);
/* harmony import */ var _helpers_time_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(487319);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29921);
/* harmony import */ var _contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(917709);







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const addPaddingNumber = (number) => number.toString().padStart(2, "0");
const SIZE = {
  s: {
    level: 3
  },
  m: {
    level: 1
  }
};
const CountdownTime = (_a) => {
  var _b = _a, {
    endAt,
    renderDaysCountdownText
  } = _b, others = __objRest(_b, [
    "endAt",
    "renderDaysCountdownText"
  ]);
  const { isMobile } = (0,_contexts_DeviceContext_es_js__WEBPACK_IMPORTED_MODULE_1__/* .useDevice */ .F)();
  const size = (0,_helpers_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .getComponentSize */ .Z)(isMobile);
  const [duration, setDuration] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_time_es_js__WEBPACK_IMPORTED_MODULE_3__/* .calculateTimeDelta */ .m)(new Date(), endAt));
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const intervalId = setInterval(() => {
      if (duration.milliseconds !== 0) {
        setDuration((0,_helpers_time_es_js__WEBPACK_IMPORTED_MODULE_3__/* .calculateTimeDelta */ .m)(new Date(), endAt));
      }
    }, 1e3);
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  const displayCountdown = () => {
    if (duration.days !== 0) {
      return !!renderDaysCountdownText ? renderDaysCountdownText(duration) : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_4__.t)("C\xF2n {{DurationDays}} ng\xE0y", { DurationDays: duration.days });
    }
    return `${addPaddingNumber(duration.hours)}:${addPaddingNumber(duration.minutes)}:${addPaddingNumber(duration.seconds)}`;
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Timer, __spreadValues({
    level: SIZE[size].level,
    weight: "bold",
    color: "white"
  }, others), displayCountdown());
};
const Timer = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Caption */ .YS)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;




/***/ }),

/***/ 488924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ index_es_FlashSaleBar; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/CountdownTime/CountdownTime.es.js
var CountdownTime_es = __webpack_require__(883578);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSaleBar/mobile/FlashSaleBar.es.js




const background = "data:image/svg+xml;base64,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";
const FlashSaleBar = ({
  text,
  endAt
}) => {
  return /* @__PURE__ */ react.createElement(Wrapper, {
    background
  }, /* @__PURE__ */ react.createElement(StyledCaption, {
    level: 3,
    weight: "bold",
    color: "white"
  }, text), endAt && /* @__PURE__ */ react.createElement(CountdownTime_es/* CountdownTime */.v, {
    level: 3,
    endAt: typeof endAt === "number" ? new Date(endAt) : endAt
  }));
};
const Wrapper = emotion_styled_browser_esm["default"].div(({ background: background2, theme }) => `
    background: url("${background2}");
    padding: 2px ${theme == null ? void 0 : theme.spacing.s8};
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    border-radius: ${theme == null ? void 0 : theme.borderRadius.xl};
`);
const StyledCaption = (0,emotion_styled_browser_esm["default"])(index_es/* Caption */.YS)`
  text-transform: uppercase;
  flex: 1 0 auto;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var BaseProps_index_es = __webpack_require__(640128);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSaleBar/desktop/FlashSaleBar.es.js




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const FlashSaleBar_es_background = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjA2IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjA2IDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxyZWN0IHdpZHRoPSIyMDYiIGhlaWdodD0iMjQiIHJ4PSIxMiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIgLz4KICA8bWFzayBpZD0ibWFzazAiIG1hc2stdHlwZT0iYWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMDYiIGhlaWdodD0iMjQiPgogICAgPHJlY3Qgd2lkdGg9IjIwNiIgaGVpZ2h0PSIyNCIgcng9IjEyIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXIpIiAvPgogIDwvbWFzaz4KICA8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CiAgICA8cmVjdCB4PSIxMDYuNjEiIHk9Ii0xOS43ODc4IiB3aWR0aD0iOC4wMjYyNSIgaGVpZ2h0PSI3NC41Mjc3IiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxMDYuNjEgLTE5Ljc4NzgpIgogICAgICBmaWxsPSJ1cmwoI3BhaW50Ml9saW5lYXIpIiAvPgogICAgPHJlY3QgeD0iMTI4Ljc3NSIgeT0iLTI2LjcyNCIgd2lkdGg9IjMuMDQ0NTYiIGhlaWdodD0iMTE1LjI1NyIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTI4Ljc3NSAtMjYuNzI0KSIKICAgICAgZmlsbD0idXJsKCNwYWludDNfbGluZWFyKSIgLz4KICAgIDxyZWN0IHg9IjE4Ni40IiB5PSItMjkuMzIxMyIgd2lkdGg9IjE2LjU1OTciIGhlaWdodD0iODYuODMzIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxODYuNCAtMjkuMzIxMykiCiAgICAgIGZpbGw9InVybCgjcGFpbnQ0X2xpbmVhcikiIC8+CiAgICA8cmVjdCB4PSIxOTMuOTE5IiB5PSItMTYiIHdpZHRoPSI3LjQ2NjQxIiBoZWlnaHQ9IjgzLjMyNDgiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDE5My45MTkgLTE2KSIKICAgICAgZmlsbD0idXJsKCNwYWludDVfbGluZWFyKSIgLz4KICA8L2c+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSIwIiB5MT0iMCIgeDI9IjE3NS40NTciIHkyPSI4Ni4xODIyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNGQTcwMEMiIC8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZGNDIxOCIgLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXIiIHgxPSIwIiB5MT0iMCIgeDI9IjE3NS40NTciIHkyPSI4Ni4xODIyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNGQTcwMEMiIC8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZGNDIxOCIgLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50Ml9saW5lYXIiIHgxPSIxMTAuNjIzIiB5MT0iLTE5Ljc4NzgiIHgyPSIxMTAuOTk2IiB5Mj0iNDguNzI1OCIKICAgICAgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjRkZEMTJFIiBzdG9wLW9wYWNpdHk9IjAuNzMiIC8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0ZGRDMzOCIgc3RvcC1vcGFjaXR5PSIwIiAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQzX2xpbmVhciIgeDE9IjEzMC4yOTciIHkxPSItMjYuNzI0IiB4Mj0iMTMyLjYxOSIgeTI9IjQyLjI4MzgiCiAgICAgIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0ZGRDEyRSIgc3RvcC1vcGFjaXR5PSIwLjczIiAvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRkQzMzgiIHN0b3Atb3BhY2l0eT0iMCIgLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50NF9saW5lYXIiIHgxPSIxOTQuNjgiIHkxPSItMjkuMzIxMyIgeDI9IjE5NS4wNTMiIHkyPSI0Ni40MTk5IgogICAgICBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNGRkQxMkUiIHN0b3Atb3BhY2l0eT0iMC43MyIgLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRkZEMzM4IiBzdG9wLW9wYWNpdHk9IjAiIC8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDVfbGluZWFyIiB4MT0iMTk3LjY1MyIgeTE9Ii0xNiIgeDI9IjE5OC40MTUiIHkyPSI1Ni42NzQ4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNGRkQxMkUiIHN0b3Atb3BhY2l0eT0iMC43MyIgLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRkZEMzM4IiBzdG9wLW9wYWNpdHk9IjAiIC8+CiAgICA8L2xpbmVhckdyYWRpZW50PgogIDwvZGVmcz4KPC9zdmc+";
const FlashSaleBar_es_FlashSaleBar = (_a) => {
  var _b = _a, {
    text,
    endAt
  } = _b, rest = __objRest(_b, [
    "text",
    "endAt"
  ]);
  return /* @__PURE__ */ react.createElement(FlashSaleBar_es_Wrapper, __spreadValues({
    background: FlashSaleBar_es_background
  }, rest), /* @__PURE__ */ react.createElement(FlashSaleBar_es_StyledCaption, {
    level: 3,
    weight: "bold",
    color: "white"
  }, text), endAt && /* @__PURE__ */ react.createElement(CountdownTime_es/* CountdownTime */.v, {
    level: 3,
    endAt: typeof endAt === "number" ? new Date(endAt) : endAt
  }));
};
const FlashSaleBar_es_Wrapper = emotion_styled_browser_esm["default"].div(({ background: background2, theme }) => `
    background: url("${background2}");
    padding: ${theme == null ? void 0 : theme.spacing.s4} ${theme == null ? void 0 : theme.spacing.s4};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
`, BaseProps_index_es/* CommonStyles */.F, "border-radius: 999px;");
const FlashSaleBar_es_StyledCaption = (0,emotion_styled_browser_esm["default"])(index_es/* Caption */.YS)`
  text-transform: uppercase;
  flex: 1 0 auto;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(917709);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSaleBar/index.es.js





var index_es_defProp = Object.defineProperty;
var index_es_getOwnPropSymbols = Object.getOwnPropertySymbols;
var index_es_hasOwnProp = Object.prototype.hasOwnProperty;
var index_es_propIsEnum = Object.prototype.propertyIsEnumerable;
var index_es_defNormalProp = (obj, key, value) => key in obj ? index_es_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var index_es_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (index_es_hasOwnProp.call(b, prop))
      index_es_defNormalProp(a, prop, b[prop]);
  if (index_es_getOwnPropSymbols)
    for (var prop of index_es_getOwnPropSymbols(b)) {
      if (index_es_propIsEnum.call(b, prop))
        index_es_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const index_es_FlashSaleBar = (props) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  if (isMobile)
    return /* @__PURE__ */ react.createElement(FlashSaleBar, index_es_spreadValues({}, props));
  return /* @__PURE__ */ react.createElement(FlashSaleBar_es_FlashSaleBar, index_es_spreadValues({}, props));
};




/***/ }),

/***/ 922859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ ProductCard; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/hook.es.js
var hook_es = __webpack_require__(339674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Quantity/Quantity.es.js
var Quantity_es = __webpack_require__(280392);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Tag/Tag.es.js
var Tag_es = __webpack_require__(991822);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/RatingFilled.es.js
var RatingFilled_es = __webpack_require__(825078);
// EXTERNAL MODULE: ../../packages/utils/dist/storage.es.js
var storage_es = __webpack_require__(653028);
// EXTERNAL MODULE: ../../.yarn/cache/dompurify-npm-3.2.5-d9af707abe-bd3b40810c.zip/node_modules/dompurify/dist/purify.es.mjs
var purify_es = __webpack_require__(629078);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/index.es.js
var helpers_index_es = __webpack_require__(649771);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js + 2 modules
var i18n_es = __webpack_require__(29921);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSaleBar/index.es.js + 2 modules
var FlashSaleBar_index_es = __webpack_require__(488924);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/assets/images/gift.es.js


var img = "data:image/svg+xml,%3csvg width='42' height='40' viewBox='0 0 42 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='42' height='40' fill='white'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M29.9375 14.7495H27.9916C28.1874 14.3922 28.2969 13.9999 28.3125 13.5998C28.2843 12.8923 27.9563 12.2234 27.399 11.7371C26.8417 11.2507 26.0998 10.9859 25.3331 10.9995C24.4198 11.0358 23.5343 11.3004 22.7711 11.765C22.008 12.2295 21.3958 12.8767 21 13.6373C20.6084 12.8788 20.0009 12.2327 19.2424 11.7682C18.484 11.3036 17.6031 11.0379 16.6937 10.9995H16.6011C15.8453 11.0006 15.1195 11.2722 14.5761 11.7571C14.0327 12.2421 13.7142 12.9026 13.6875 13.5998V13.6493C13.7034 14.0322 13.8084 14.4074 13.9954 14.7495H12.0625C11.847 14.7495 11.6403 14.8285 11.488 14.9692C11.3356 15.1098 11.25 15.3006 11.25 15.4995V17.7495C11.25 17.9484 11.3356 18.1392 11.488 18.2799C11.6403 18.4205 11.847 18.4995 12.0625 18.4995H29.9375C30.153 18.4995 30.3597 18.4205 30.512 18.2799C30.6644 18.1392 30.75 17.9484 30.75 17.7495V15.4995C30.75 15.3006 30.6644 15.1098 30.512 14.9692C30.3597 14.8285 30.153 14.7495 29.9375 14.7495ZM25.3583 12.4995C25.6901 12.4916 26.0127 12.6011 26.2598 12.8057C26.507 13.0103 26.66 13.2944 26.6875 13.5998C26.676 13.9068 26.5364 14.1978 26.298 14.412C26.0595 14.6263 25.7406 14.7472 25.4078 14.7495H22.2009C22.7063 13.8053 23.7113 12.4995 25.3583 12.4995ZM15.3125 13.6245C15.3333 13.3176 15.4809 13.0298 15.725 12.8205C15.969 12.6111 16.2908 12.4962 16.6239 12.4995C18.3049 12.5055 19.2897 13.7978 19.8007 14.7495H16.632C16.2984 14.7518 15.9763 14.6368 15.7312 14.4279C15.4862 14.2189 15.3364 13.9317 15.3125 13.6245ZM22.625 19.9997V28.9997H26.6875C27.334 28.9997 27.9539 28.7626 28.4111 28.3407C28.8682 27.9187 29.125 27.3464 29.125 26.7497V19.9997H22.625ZM12.875 19.9997H19.375V28.9997H15.3125C14.666 28.9997 14.046 28.7626 13.5889 28.3407C13.1318 27.9187 12.875 27.3464 12.875 26.7497V19.9997Z' fill='%23F5222D'/%3e%3c/svg%3e";
var giftImg = img;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCard/ProductGiftItem.es.js




const ProductGiftItem = (props) => {
  const { gift } = props;
  return /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    width: 40,
    height: 40,
    borderRadius: "m",
    borderWeight: "m",
    borderColor: "divider",
    borderStyle: "solid",
    backgroundColor: "white",
    onClick: (e) => e.preventDefault()
  }, /* @__PURE__ */ react.createElement(StyledLazyImage, {
    src: gift.src,
    customFallbackImage: giftImg,
    height: 38,
    width: 38,
    imageWidth: 76,
    borderRadius: 8,
    alt: gift.alt,
    contain: true,
    aspectRatio: 1,
    draggable: false
  }));
};
var ProductGiftItem$1 = ProductGiftItem;
const StyledLazyImage = (0,emotion_styled_browser_esm["default"])(LazyImage_es/* LazyImage */.w)`
  & > img {
    border-radius: 0.5rem;
    display: block;
  }
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/contexts/DeviceContext.es.js
var DeviceContext_es = __webpack_require__(917709);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCard/ProductGifts.es.js





const ProductGifts = (props) => {
  var _a;
  const { gifts, hasGift } = props;
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const containerRef = (0,react.useRef)(null);
  const startPos = (0,react.useRef)({
    startX: 0,
    scrollLeft: 0,
    isMouseDown: false
  });
  (0,react.useEffect)(() => {
    const container = containerRef.current;
    const handleMouseDown = (e) => {
      if (!container) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      const startX = e.pageX - container.offsetLeft;
      const scrollLeft = container.scrollLeft;
      startPos.current = {
        startX,
        scrollLeft,
        isMouseDown: true
      };
      document.body.style.cursor = "grabbing";
    };
    const handleMouseMove = (e) => {
      if (!startPos.current.isMouseDown || !container) {
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walkX = x - startPos.current.startX;
      container.scrollLeft = startPos.current.scrollLeft - walkX;
    };
    const handleMouseUp = () => {
      if (!container) {
        return;
      }
      startPos.current.isMouseDown = false;
      document.body.style.cursor = "default";
    };
    container == null ? void 0 : container.addEventListener("mousedown", handleMouseDown);
    container == null ? void 0 : container.addEventListener("mousemove", handleMouseMove);
    container == null ? void 0 : container.addEventListener("mouseup", handleMouseUp);
    return () => {
      container == null ? void 0 : container.removeEventListener("mousedown", handleMouseDown);
      container == null ? void 0 : container.removeEventListener("mousemove", handleMouseMove);
      container == null ? void 0 : container.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);
  if (!hasGift || !((_a = gifts == null ? void 0 : gifts.images) == null ? void 0 : _a.length))
    return null;
  return /* @__PURE__ */ react.createElement(Container, {
    ref: containerRef,
    padding: "s4",
    borderRadius: "m",
    backgroundColor: "background",
    marginBottom: isMobile ? "s12" : void 0,
    onClick: (e) => e.preventDefault()
  }, gifts.images.map((image, index) => {
    return /* @__PURE__ */ react.createElement(ProductGiftItem$1, {
      key: index,
      gift: image
    });
  }));
};
var ProductGifts$1 = ProductGifts;
const Container = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)`
  overflow: auto hidden;
  gap: 4px;
  display: flex;
  flex-direction: row;
  ::-webkit-scrollbar {
    //Hide scrollbar for Chrome, Safari and Opera
    display: none;
  }
  // Hide scrollbar for IE and Edge
  -ms-overflow-style: none;
  // Hide scrollbar for Firefox
  scrollbar-width: none;
`;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/hooks/useQuantity.es.js
var useQuantity_es = __webpack_require__(194446);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/FlashSaleBadge/FlashSaleBadge.es.js






const background = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTAgNEMwIDEuNzkwODYgMS43OTA4NiAwIDQgMEgzNkMzOC4yMDkxIDAgNDAgMS43OTA4NiA0MCA0VjM1LjgzODdDNDAgMzcuNTE1OCAzOC4wNjAxIDM4LjQ0ODEgMzYuNzUwNiAzNy40MDA1TDM2LjI0OTQgMzYuOTk5NUMzNS41MTkgMzYuNDE1MiAzNC40ODEgMzYuNDE1MiAzMy43NTA2IDM2Ljk5OTVMMzEuMjQ5NCAzOS4wMDA1QzMwLjUxOSAzOS41ODQ4IDI5LjQ4MSAzOS41ODQ4IDI4Ljc1MDYgMzkuMDAwNUwyNi4yNDk0IDM2Ljk5OTVDMjUuNTE5IDM2LjQxNTIgMjQuNDgxIDM2LjQxNTIgMjMuNzUwNiAzNi45OTk1TDIxLjI0OTQgMzkuMDAwNUMyMC41MTkgMzkuNTg0OCAxOS40ODEgMzkuNTg0OCAxOC43NTA2IDM5LjAwMDVMMTYuMjQ5NCAzNi45OTk1QzE1LjUxOSAzNi40MTUyIDE0LjQ4MSAzNi40MTUyIDEzLjc1MDYgMzYuOTk5NUwxMS4yNDk0IDM5LjAwMDVDMTAuNTE5IDM5LjU4NDggOS40ODEwNSAzOS41ODQ4IDguNzUwNjEgMzkuMDAwNUw2LjI0OTM5IDM2Ljk5OTVDNS41MTg5NSAzNi40MTUyIDQuNDgxMDUgMzYuNDE1MiAzLjc1MDYxIDM2Ljk5OTVMMy4yNDkzOSAzNy40MDA1QzEuOTM5ODYgMzguNDQ4MSAwIDM3LjUxNTggMCAzNS44Mzg3VjRaIgogICAgZmlsbD0iI0ZGREU2NyIgLz4KPC9zdmc+";
const SIZE = {
  s: {
    badge: 36,
    discountText: 8,
    percentText: 13
  },
  m: {
    badge: 40,
    discountText: 10,
    percentText: 15
  }
};
const FlashSaleBadge = ({
  discountPercent
}) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const size = (0,helpers_index_es/* getComponentSize */.Z)(isMobile);
  return discountPercent ? /* @__PURE__ */ react.createElement(DiscountInfo, {
    size,
    background
  }, /* @__PURE__ */ react.createElement(DiscountText, {
    size
  }, (0,i18n_es.t)("GI\u1EA2M")), /* @__PURE__ */ react.createElement(PercentText, {
    size
  }, discountPercent, "%")) : null;
};
const DiscountText = emotion_styled_browser_esm["default"].div(({ size }) => `
    font-weight: 700;
    color: #663009;
    line-height: 12px;
    font-size: ${SIZE[size].discountText}px;
`);
const PercentText = emotion_styled_browser_esm["default"].div(({ size }) => `
    font-weight: 700;
    font-size: ${SIZE[size].percentText}px;
    line-height: 18px;
    color: #ee112e;
`);
const DiscountInfo = emotion_styled_browser_esm["default"].div(({ size, background: background2 }) => `
    width: ${SIZE[size].badge}px;
    height: ${SIZE[size].badge}px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url("${background2}");
    background-repeat: no-repeat;
    background-size: cover;
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/helpers/number.es.js
var number_es = __webpack_require__(54230);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/SavingBadge/SavingBadge.es.js






const SavingBadge_es_background = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA5NiA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iOTYiIGhlaWdodD0iNDAiIHJ4PSI0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIiAvPgogIDxtYXNrIGlkPSJtYXNrMCIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9Ijk2IiBoZWlnaHQ9IjQwIj4KICAgIDxyZWN0IHdpZHRoPSI5NiIgaGVpZ2h0PSI0MCIgcng9IjQiIGZpbGw9IndoaXRlIiAvPgogIDwvbWFzaz4KICA8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CiAgICA8cGF0aCBvcGFjaXR5PSIwLjMiCiAgICAgIGQ9Ik03NC4yNDQ2IC05LjAyODY5TDY1Ljg3NjcgOC45MTYyMUw3MC43NzA4IDExLjE5ODNMNjMuOTI0NCAyNS44ODA1TDg0LjQ3MjQgMTEuNjI5M0w3Ny45NDcgOC41ODY0Mkw5MC41NTgxIC0xLjQyMTU2TDc0LjI0NDYgLTkuMDI4NjlaIgogICAgICBmaWxsPSIjMUIxRDI5IiAvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjM1LjcyMDkiIHkxPSIxLjY2NTQ0ZS0wNiIgeDI9IjU3Ljg4ODYiIHkyPSI0MC4wODczIgogICAgICBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNBQTIwRkYiIC8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzQxM0VGRiIgLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgo8L3N2Zz4=";
const SavingBadge_es_SIZE = {
  s: {
    titleFont: 8,
    discountFont: 12,
    discountLineHeight: 16
  },
  m: {
    titleFont: 10,
    discountFont: 13,
    discountLineHeight: 18
  }
};
const SavingBadge = ({
  savingAmount,
  numberDisplayFormat
}) => {
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const size = isMobile ? "s" : "m";
  const formattedSavingAmount = (0,number_es/* formatCurrency */.xG)(savingAmount, numberDisplayFormat);
  return /* @__PURE__ */ react.createElement(Wrapper, {
    background: SavingBadge_es_background
  }, /* @__PURE__ */ react.createElement(Title, {
    size
  }, (0,i18n_es.t)("TI\u1EBET KI\u1EC6M")), /* @__PURE__ */ react.createElement(DiscountAmount, {
    size
  }, formattedSavingAmount));
};
const Wrapper = emotion_styled_browser_esm["default"].div(({ background: background2, theme }) => `
  height: 36px;
  line-height: 12px;
  background: url("${background2}");
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${theme == null ? void 0 : theme.spacing.s4} ${theme == null ? void 0 : theme.spacing.s8};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.s};
  background-size: cover;
`);
const Title = emotion_styled_browser_esm["default"].div(({ size }) => `
    font-size: ${SavingBadge_es_SIZE[size].titleFont}px;
    font-weight: 700;
    color: #ffd591;
`);
const DiscountAmount = emotion_styled_browser_esm["default"].div(({ size, theme }) => `
    font-size: ${SavingBadge_es_SIZE[size].discountFont}px;
    line-height: ${SavingBadge_es_SIZE[size].discountLineHeight}px;
    font-weight: 700;
    color: ${theme == null ? void 0 : theme.colors.white};
`);



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(591007);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/EnhancedImage/EnhancedImage.es.js
var EnhancedImage_es = __webpack_require__(788925);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductCard/ProductCard.es.js



















var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const FreeShippingColored = dynamic_default()(() => Promise.all(/* import() */[__webpack_require__.e(10433), __webpack_require__.e(88677), __webpack_require__.e(32708)]).then(__webpack_require__.bind(__webpack_require__, 588677)).then((mod) => mod.FreeShippingColored));
const ProductCard_es_SIZE = {
  s: {
    padding: "s12"
  },
  m: {
    padding: "s16"
  }
};
const ProductCard = (_a) => {
  var _b = _a, {
    name,
    link,
    imageUrl,
    price,
    freeship,
    hasGift,
    gifts = {},
    infoTags,
    titleTag,
    ctaButton,
    ctaButtons,
    wishlistButton,
    contactButton,
    stockQuantity,
    flashSale,
    addToCart,
    textColor,
    brand,
    tracking,
    ctaTracking,
    needConfirmAge,
    type,
    uom,
    precisionToDisplayDecimalQuantity: precision,
    bestComboDiscount,
    benefitLabel,
    requiredQuantity,
    numberDisplayFormat,
    selectPromotionId,
    showNewProductGift = false,
    highlight,
    materials,
    showCtaButtonsWithQuantity = false,
    showCtaButtonsRelevantProducts = false,
    averageRating,
    onWrapperAuxClick,
    onWrapperClick,
    customButtons
  } = _b, props = __objRest(_b, [
    "name",
    "link",
    "imageUrl",
    "price",
    "freeship",
    "hasGift",
    "gifts",
    "infoTags",
    "titleTag",
    "ctaButton",
    "ctaButtons",
    "wishlistButton",
    "contactButton",
    "stockQuantity",
    "flashSale",
    "addToCart",
    "textColor",
    "brand",
    "tracking",
    "ctaTracking",
    "needConfirmAge",
    "type",
    "uom",
    "precisionToDisplayDecimalQuantity",
    "bestComboDiscount",
    "benefitLabel",
    "requiredQuantity",
    "numberDisplayFormat",
    "selectPromotionId",
    "showNewProductGift",
    "highlight",
    "materials",
    "showCtaButtonsWithQuantity",
    "showCtaButtonsRelevantProducts",
    "averageRating",
    "onWrapperAuxClick",
    "onWrapperClick",
    "customButtons"
  ]);
  var _a2, _b2, _c;
  const { isMobile } = (0,DeviceContext_es/* useDevice */.F)();
  const { showModal } = (0,hook_es/* useModal */.d)();
  const router = (0,next_router.useRouter)();
  const {
    quantity,
    setQuantity,
    handleUpdateQuantity,
    onIncrease,
    onDecrease,
    loading
  } = (0,useQuantity_es/* useQuantity */.R)({
    addToCart,
    precision,
    shouldRoundValue: !numberDisplayFormat
  });
  const handleClickCtaButton = (e) => {
    var _a3;
    e.preventDefault();
    if (needConfirmAge) {
      showModal == null ? void 0 : showModal({
        title: isMobile ? (0,i18n_es.t)("C\u1EA3nh b\xE1o") : "",
        children: isMobile ? /* @__PURE__ */ react.createElement(index_es/* Body */.uT, null, (0,i18n_es.t)("src.components.ProductCard.ProductCard.0")) : /* @__PURE__ */ react.createElement(ModalConfirmWrap, null, (0,i18n_es.t)("src.components.ProductCard.ProductCard.0")),
        okText: (0,i18n_es.t)("T\xF4i tr\xEAn 18 tu\u1ED5i"),
        cancelText: (0,i18n_es.t)("T\xF4i d\u01B0\u1EDBi 18 tu\u1ED5i"),
        onOk: () => {
          (0,storage_es/* setCookieOver18YearOld */.zr)(true);
          addToCart == null ? void 0 : addToCart.onAddToCart();
        },
        width: isMobile ? "90%" : "400px",
        okButtonProps: { block: isMobile, size: "s" },
        cancelButtonProps: { block: isMobile, size: "s" },
        alignFooter: "center",
        showCloseIcon: isMobile
      });
    } else
      (_a3 = ctaButton == null ? void 0 : ctaButton.onClick) == null ? void 0 : _a3.call(ctaButton, e);
  };
  const size = (0,helpers_index_es/* getComponentSize */.Z)(isMobile);
  const renderCtaButtons = (quantityInCart) => {
    if (quantityInCart > 0 && !showCtaButtonsWithQuantity && !showCtaButtonsRelevantProducts) {
      return null;
    }
    return /* @__PURE__ */ react.createElement(react.Fragment, null, !!(ctaButtons == null ? void 0 : ctaButtons.length) && ctaButtons.map((ctaButton2, index) => typeof ctaButton2.children === "string" ? /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(__spreadValues(__spreadValues({
      key: index
    }, ctaButton2), ctaTracking), {
      size: "s",
      block: true,
      padding: "s0"
    })) : /* @__PURE__ */ react.createElement(react.Fragment, {
      key: index
    }, ctaButton2.children)), !(ctaButtons == null ? void 0 : ctaButtons.length) ? !!ctaButton ? /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(__spreadValues(__spreadProps(__spreadValues({}, ctaButton), {
      onClick: (e) => {
        ctaButton.onClick && handleClickCtaButton(e);
      }
    }), ctaTracking), {
      size: "s",
      block: true,
      padding: "s0"
    })) : !!contactButton ? /* @__PURE__ */ react.createElement(Button_es/* Button */.z, __spreadProps(__spreadValues(__spreadValues({}, contactButton), ctaTracking), {
      size: "s",
      block: true,
      padding: "s0"
    })) : null : null);
  };
  const renderButton = () => {
    const { quantityInCart = 0 } = addToCart || {};
    return /* @__PURE__ */ react.createElement(react.Fragment, null, renderCtaButtons(quantityInCart), (quantityInCart != null ? quantityInCart : 0) > 0 ? /* @__PURE__ */ react.createElement(Quantity_es/* Quantity */.h, __spreadProps(__spreadValues({
      block: true,
      quantity,
      setQuantity,
      onMinus: onDecrease,
      onPlus: onIncrease,
      min: 0,
      max: Math.min(stockQuantity, 999),
      color: "primary500",
      size: "s",
      onBlur: handleUpdateQuantity,
      onKeyPress: (e) => {
        if (e.key === "Enter")
          handleUpdateQuantity();
      },
      decimalSeparator: !!numberDisplayFormat ? (numberDisplayFormat == null ? void 0 : numberDisplayFormat.decimalSeparator) || "," : "."
    }, !!numberDisplayFormat ? {
      formatter: (value) => (0,number_es/* numberFormatter */.V2)(value, numberDisplayFormat),
      parser: (value) => (0,number_es/* numberParser */.kX)(value, numberDisplayFormat)
    } : {}), {
      precision,
      disabled: loading
    })) : null);
  };
  const productVisualWrapper = /* @__PURE__ */ react.createElement(ProductVisualWrapper, null, /* @__PURE__ */ react.createElement(ProductImageWrapper, null, /* @__PURE__ */ react.createElement(ProductImage, {
    hover: "zoom",
    height: "100%",
    objectFit: "contain",
    src: imageUrl,
    googleImageParams: {
      width: 230
    },
    aspectRatio: 1,
    alt: name
  }), !!requiredQuantity ? /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    width: 40,
    height: 40
  }, requiredQuantity) : null), ((_a2 = infoTags == null ? void 0 : infoTags.length) != null ? _a2 : 0) > 0 ? /* @__PURE__ */ react.createElement(InfoTagsWrapper, null, infoTags == null ? void 0 : infoTags.map((tag, index) => /* @__PURE__ */ react.createElement(InfoTag, __spreadValues({
    key: index
  }, tag)))) : null, flashSale ? /* @__PURE__ */ react.createElement(react.Fragment, null, flashSale.discountPercent && /* @__PURE__ */ react.createElement(FlashSaleBadgeWrapper, null, /* @__PURE__ */ react.createElement(FlashSaleBadge, {
    discountPercent: flashSale.discountPercent
  })), /* @__PURE__ */ react.createElement(FlashSaleTimerWrapper, null, /* @__PURE__ */ react.createElement(FlashSaleBar_index_es/* FlashSaleBar */.P, __spreadProps(__spreadValues({}, flashSale), {
    endAt: typeof flashSale.endAt === "number" ? new Date(flashSale.endAt) : flashSale.endAt
  })))) : null, (price == null ? void 0 : price.discountAmount) ? /* @__PURE__ */ react.createElement(SavingBadgeWrapper, null, /* @__PURE__ */ react.createElement(SavingBadge, {
    savingAmount: price.discountAmount,
    numberDisplayFormat
  })) : null);
  const productName = /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    align: "center",
    justify: "space-between"
  }, brand && /* @__PURE__ */ react.createElement(Brand, null, /* @__PURE__ */ react.createElement(index_es/* Body */.uT, {
    level: 2,
    line: 1,
    color: "textSecondary",
    hoverColor: "primary500",
    style: { textTransform: "uppercase" },
    onClick: (event) => {
      event.preventDefault();
      brand.code && router.push({
        pathname: "/brands/[brandId]",
        query: {
          brandId: brand.code
        }
      }, `/${brand.code}-brand.${brand.code}`);
    },
    className: "product-brand-name"
  }, brand.name)), wishlistButton && /* @__PURE__ */ react.createElement(Brand, null, /* @__PURE__ */ react.createElement(react.Fragment, null, wishlistButton.children))), /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(ProductNameWrapper, null, /* @__PURE__ */ react.createElement(index_es/* Caption */.YS, {
    className: "att-product-card-title",
    level: 1,
    line: bestComboDiscount && Number(bestComboDiscount) !== 0 || !!benefitLabel ? 2 : 3,
    color: textColor || "textPrimary"
  }, titleTag && /* @__PURE__ */ react.createElement(TitleTag, __spreadValues({}, titleTag)), /* @__PURE__ */ react.createElement(StyledH3, {
    title: name
  }, name))), uom && /* @__PURE__ */ react.createElement(index_es/* Caption */.YS, {
    level: 1,
    color: "textSecondary",
    style: { marginTop: "0.25rem" }
  }, (0,i18n_es.t)("\u0110\u01A1n v\u1ECB t\xEDnh"), ": ", uom), bestComboDiscount && Number(bestComboDiscount) !== 0 ? /* @__PURE__ */ react.createElement(Tag_es/* Tag */.V, {
    type: "ghost",
    variant: "branding",
    content: `${(0,i18n_es.t)("Combo gi\u1EA3m ~").toLocaleUpperCase()} ${(0,number_es/* formatCurrency */.xG)(Number(bestComboDiscount), numberDisplayFormat)}`,
    style: { wordBreak: "break-all" }
  }) : !!benefitLabel ? /* @__PURE__ */ react.createElement(Tag_es/* Tag */.V, {
    type: "ghost",
    variant: "branding",
    content: benefitLabel,
    style: { wordBreak: "break-all" }
  }) : null, /* @__PURE__ */ react.createElement(ProductSaleInfo, {
    freeship: !!freeship
  }, freeship && /* @__PURE__ */ react.createElement(StyledIconWrapper, null, /* @__PURE__ */ react.createElement(FreeShippingColored, {
    size: 24
  })), !!price ? /* @__PURE__ */ react.createElement(ProductPrice_es/* ProductPrice */.j, __spreadProps(__spreadValues({}, price), {
    numberDisplayFormat
  })) : null)));
  const highlightAttribute = highlight ? /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    padding: "s8",
    borderRadius: "m",
    backgroundColor: "background"
  }, /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    dangerouslySetInnerHTML: {
      __html: (_c = (_b2 = purify_es/* default */.Z) == null ? void 0 : _b2.sanitize) == null ? void 0 : _c.call(_b2, highlight)
    },
    style: { fontSize: "10px", lineHeight: "10px" }
  })) : null;
  const linkWithSelectPromotionId = (0,react.useMemo)(() => {
    var _a3;
    if (!selectPromotionId || !link || !(link == null ? void 0 : link.as) || typeof link.as === "string" || !link.as.query || typeof link.as.query !== "object") {
      return link;
    }
    return __spreadProps(__spreadValues({}, link), {
      as: __spreadProps(__spreadValues({}, link.as), { query: __spreadProps(__spreadValues({}, (_a3 = link == null ? void 0 : link.as) == null ? void 0 : _a3.query), { selectPromotionId }) })
    });
  }, [link, selectPromotionId]);
  const productGift = () => {
    var _a3;
    if (!hasGift || !((_a3 = gifts == null ? void 0 : gifts.images) == null ? void 0 : _a3.length))
      return;
    const images = gifts.images.slice(0, 2);
    const more = gifts.images.length - 2;
    return /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
      align: "center",
      gap: "s4"
    }, images.map((image, index) => /* @__PURE__ */ react.createElement(StyledGift, {
      width: 24,
      height: 24,
      key: index
    }, /* @__PURE__ */ react.createElement(LazyImage_es/* LazyImage */.w, {
      src: image.src,
      height: "100%",
      width: "100%",
      borderRadius: 4,
      alt: image.alt,
      contain: true
    }))), more > 0 && /* @__PURE__ */ react.createElement(MoreGift, {
      width: 24,
      height: 24
    }, "+", more));
  };
  const card = type === "list" ? /* @__PURE__ */ react.createElement("div", __spreadValues({
    style: { display: "flex", padding: "12px" },
    className: "product-card",
    onAuxClick: onWrapperAuxClick,
    onClick: onWrapperClick
  }, tracking), /* @__PURE__ */ react.createElement("div", {
    style: { flex: 3 }
  }, productVisualWrapper), /* @__PURE__ */ react.createElement("div", {
    style: { flex: 7, marginLeft: "12px", maxWidth: "70%" }
  }, productName, /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    marginBottom: "s8"
  }, highlightAttribute), showNewProductGift ? /* @__PURE__ */ react.createElement(ProductGifts$1, {
    gifts,
    hasGift
  }) : productGift(), /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    direction: "column",
    gap: "s4",
    justify: "end",
    align: "start",
    width: "100%"
  }, !!averageRating && averageRating > 1 && /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    backgroundColor: "#FFE7BA",
    borderRadius: "s",
    maxWidth: "fit-content"
  }, /* @__PURE__ */ react.createElement(Row_es/* Row */.X, {
    maxWidth: "fit-content",
    align: "middle",
    padding: ["s0", "s4"]
  }, /* @__PURE__ */ react.createElement(RatingFilled_es/* RatingFilled */.A, {
    color: "pending",
    size: "13px"
  }), /* @__PURE__ */ react.createElement(AverageRating, null, averageRating.toFixed(1)))), /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    direction: showCtaButtonsRelevantProducts || !isMobile ? "row" : "column",
    gap: "s8",
    width: "100%",
    align: "center"
  }, customButtons ? customButtons : renderButton())))) : /* @__PURE__ */ react.createElement(ProductCard_es_Wrapper, __spreadValues({
    size,
    className: "product-card",
    onAuxClick: onWrapperAuxClick,
    onClick: onWrapperClick
  }, tracking), /* @__PURE__ */ react.createElement(ProductLink, __spreadValues(__spreadValues({}, linkWithSelectPromotionId), props), /* @__PURE__ */ react.createElement(ProductCardContent, null, productVisualWrapper, productName, !!highlightAttribute && /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    marginBottom: "s8"
  }, highlightAttribute), showNewProductGift ? /* @__PURE__ */ react.createElement(ProductGifts$1, {
    gifts,
    hasGift
  }) : productGift())), /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    direction: "column",
    gap: "s4",
    justify: "end",
    align: "start",
    width: "100%"
  }, !!averageRating && averageRating > 1 && /* @__PURE__ */ react.createElement(Shape_index_es/* Shape */.b, {
    backgroundColor: "#FFE7BA",
    borderRadius: "s",
    maxWidth: "fit-content"
  }, /* @__PURE__ */ react.createElement(Row_es/* Row */.X, {
    maxWidth: "fit-content",
    align: "middle",
    padding: ["s0", "s4"]
  }, /* @__PURE__ */ react.createElement(RatingFilled_es/* RatingFilled */.A, {
    color: "pending",
    size: "13px"
  }), /* @__PURE__ */ react.createElement(AverageRating, null, averageRating.toFixed(1)))), /* @__PURE__ */ react.createElement(Flex_es/* Flex */.k, {
    direction: showCtaButtonsRelevantProducts || !isMobile ? "row" : "column",
    align: "center",
    gap: "s8",
    width: "100%"
  }, customButtons ? customButtons : renderButton())));
  return card;
};
const ProductLink = (0,emotion_styled_browser_esm["default"])(CustomLink_es/* CustomLink */.x)`
  display: block;
`;
const ProductCard_es_Wrapper = emotion_styled_browser_esm["default"].div(({ theme, size }) => `
    position: relative;
    width: 100%;
    height: 100%;
    padding: ${theme == null ? void 0 : theme.spacing[ProductCard_es_SIZE[size].padding]};
    display: flex;
    flex-direction: column;
    background-color: #fff;
    justify-content: space-between;
   `);
const StyledIconWrapper = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  right: 0;
  width: auto;
`;
const ProductCardContent = emotion_styled_browser_esm["default"].div(({ theme }) => `
    position: relative;
    flex: 1 0 auto;
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s8};
`);
const ProductVisualWrapper = emotion_styled_browser_esm["default"].div(({ theme }) => `
    position: relative;
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s4};
`);
const ProductSaleInfo = emotion_styled_browser_esm["default"].div(({ theme, freeship }) => `
    position: relative;
    margin-top: ${theme.spacing.s4};
    padding-right: ${freeship ? "1.5rem" : "unset"} ;
    margin-bottom: ${theme.spacing.s4}
`);
const Brand = emotion_styled_browser_esm["default"].div(({ theme }) => `
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s4};
`);
const TitleTag = (0,emotion_styled_browser_esm["default"])(Tag_es/* Tag */.V)(({ theme }) => `
  margin-right: ${theme == null ? void 0 : theme.spacing.s4};
`);
const InfoTag = (0,emotion_styled_browser_esm["default"])(Tag_es/* Tag */.V)(({ theme }) => `
    margin-bottom: ${theme == null ? void 0 : theme.spacing.s4};
  `);
const InfoTagsWrapper = emotion_styled_browser_esm["default"].div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  top: 0;
  left: 0;
`;
const FlashSaleBadgeWrapper = emotion_styled_browser_esm["default"].div`
  position: absolute;
  top: 0;
  right: 0;
`;
const FlashSaleTimerWrapper = emotion_styled_browser_esm["default"].div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;
const SavingBadgeWrapper = emotion_styled_browser_esm["default"].div`
  position: absolute;
  bottom: 0;
  left: 0;
`;
const ProductImageWrapper = emotion_styled_browser_esm["default"].div`
  position: relative;
  padding-bottom: 100%;
`;
const ProductImage = (0,emotion_styled_browser_esm["default"])(EnhancedImage_es/* EnhancedImage */.N)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  object-fit: contain;
`;
const ProductNameWrapper = emotion_styled_browser_esm["default"].div`
  height: 3rem;
`;
const ModalConfirmWrap = emotion_styled_browser_esm["default"].h5`
  margin-bottom: 0;
  color: ${(p) => p.theme.colors.textTitle};
  text-align: center;
`;
const StyledH3 = emotion_styled_browser_esm["default"].h3`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  display: inline;
`;
const StyledGift = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.secondary50};
`;
const MoreGift = (0,emotion_styled_browser_esm["default"])(Shape_index_es/* Shape */.b)`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.secondary50};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
`;
const AverageRating = emotion_styled_browser_esm["default"].div`
  line-height: 16px;
  font-size: 12px;
  margin-left: 4px;
  font-weight: 400;
`;




/***/ }),

/***/ 649771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getComponentSize; }
/* harmony export */ });
const getComponentSize = (isMobile) => {
  return isMobile ? "s" : "m";
};




/***/ }),

/***/ 487319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ calculateTimeDelta; }
/* harmony export */ });
const calculateTimeDelta = (startTime, endTime) => {
  const fromTimestamp = startTime.getTime();
  const endTimestamp = endTime.getTime();
  const durationInMs = endTimestamp - fromTimestamp;
  const durationInSecond = Math.max(0, Math.round(durationInMs / 1e3));
  return {
    milliseconds: durationInMs,
    days: Math.floor(durationInSecond / (3600 * 24)),
    hours: Math.floor(durationInSecond / 3600 % 24),
    minutes: Math.floor(durationInSecond / 60 % 60),
    seconds: Math.floor(durationInSecond % 60)
  };
};




/***/ }),

/***/ 194446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useQuantity; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(775002);



const DELAY = 300;
const useQuantity = ({
  addToCart,
  baseQuantity = 0,
  precision = 0,
  shouldRoundValue = true
}) => {
  const [quantity, setQuantity] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((addToCart == null ? void 0 : addToCart.quantityInCart) || baseQuantity);
  const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (addToCart && !loading) {
      setQuantity(addToCart.quantityInCart || baseQuantity);
    }
  }, [addToCart]);
  const updateQuantity = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (quantity2) => {
    var _a;
    setLoading(true);
    const normalizedQuantity = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.toFixed)({
      value: quantity2,
      precision,
      shouldRoundValue
    });
    if (normalizedQuantity === 0) {
      await ((_a = addToCart == null ? void 0 : addToCart.onRemoveItem) == null ? void 0 : _a.call(addToCart));
    } else {
      await (addToCart == null ? void 0 : addToCart.onChangeQuantity(normalizedQuantity));
    }
    setLoading(false);
  }, [addToCart, precision, shouldRoundValue]);
  const handleUpdateQuantity = async () => {
    if (quantity && quantity !== (addToCart == null ? void 0 : addToCart.quantityInCart)) {
      await updateQuantity(quantity);
    } else {
      setQuantity((addToCart == null ? void 0 : addToCart.quantityInCart) || baseQuantity);
    }
  };
  const debounceChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    const debounceUpdate = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_1__.debounce)(async (quantity2, onError) => {
      try {
        await updateQuantity(quantity2);
      } catch (error) {
        onError == null ? void 0 : onError(error);
      }
    }, DELAY);
    return (newQuantity) => {
      setQuantity(newQuantity);
      debounceUpdate(newQuantity, () => setQuantity((addToCart == null ? void 0 : addToCart.quantityInCart) || baseQuantity));
    };
  }, [addToCart == null ? void 0 : addToCart.quantityInCart, baseQuantity, updateQuantity]);
  const onIncrease = () => {
    debounceChange(quantity + 1);
  };
  const onDecrease = () => {
    debounceChange(quantity - 1);
  };
  return {
    quantity,
    setQuantity,
    handleUpdateQuantity,
    onIncrease,
    onDecrease,
    loading
  };
};




/***/ })

}]);